<mat-sidenav-container color="primary">
    <mat-sidenav mode="side" opened color="primary">
        <mat-nav-list>
            <app-menu-list-item *ngFor="let item of navItems" [item]="item"></app-menu-list-item>
        </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
        <div style="margin-left: 30px;margin-right: 30px;" fxLayout="column"  class="mat-elevation-z1">
            <div>
                <mat-toolbar style="margin-top: 10px;" color="primary" fxFlex="100%" fxLayout="column">
                    <mat-toolbar-row fxLayoutAlign="center" fxLayout="column" fxFlex="100%">
                        <h2 fxFlexAlign="center">Personal Details</h2>
                    </mat-toolbar-row>
                    <!-- <mat-toolbar-row fxLayout="row" fxFlex="100%" > -->
                        <!-- <button [disabled]="personalDetailsDataEntryForm.invalid" matTooltip="Save Personal Details" mat-icon-button (click)="saveConfirmation()"> <mat-icon>save</mat-icon> Save </button> -->
                        <!-- Added By Navin on 15/2/24 -->
                        <!-- <button style="background-color: #4b5dc5; width: 55px; height: 36px; border-radius: 13px; margin-bottom: 3px; text-align: center;" [disabled]="personalDetailsDataEntryForm.invalid" matTooltip="Save Personal Details" mat-icon-button (click)="saveConfirmation()">  Save </button>
                    </mat-toolbar-row> -->
                </mat-toolbar>
            </div>
            <div style="margin-top: 10px;" fxFlex="100%">
                <form [formGroup]="personalDetailsDataEntryForm">
                    <mat-grid-list cols="3" rowHeight="70px">
                        <mat-grid-tile *ngFor="let personalDetailsField of personalDetailsFields">

                            <mat-form-field style="width:95%;margin-top: 15px;"  *ngIf="personalDetailsField.type=='TEXT'" appearance="outline" >
                              <div *ngIf="personalDetailsField.value; else default">
                                <input *ngIf="personalDetailsField.value; else default"  formControlName="{{personalDetailsField.name}}" required="{{personalDetailsField.mandatory}}" matInput size="30" [attr.maxlength]="getFieldSize(personalDetailsField)" type="text"  ngDefaultControl [(ngModel)]="personalDetailsField.value" placeholder={{personalDetailsField.label}}>
                              </div>
                              <ng-template #default>
                                <input #default formControlName="{{personalDetailsField.name}}" required="{{personalDetailsField.mandatory}}" matInput size="30" [attr.maxlength]="getFieldSize(personalDetailsField)" type="text"  placeholder={{personalDetailsField.label}}>
                              </ng-template>
                                <mat-label>{{personalDetailsField.label}}</mat-label>
                            </mat-form-field> 
 

                            <mat-form-field style="width:95%;margin-top: 15px;"  *ngIf="personalDetailsField.type=='DATE'" appearance="outline">
                              <div *ngIf="personalDetailsField.value; else datedefault">
                                <input  formControlName={{personalDetailsField.name}} required="{{personalDetailsField.mandatory}}" matInput size="11" maxlength="11" type="date" ngDefaultControl [(ngModel)]="personalDetailsField.value" placeholder={{personalDetailsField.label}}>
                              </div>
                              <ng-template #datedefault>
                                <input formControlName={{personalDetailsField.name}} required="{{personalDetailsField.mandatory}}" matInput size="11" maxlength="11" type="date"  placeholder={{personalDetailsField.label}}>
                              </ng-template>
                                <mat-label>{{personalDetailsField.label}}</mat-label>
                            </mat-form-field>

                        </mat-grid-tile>
                        
                    </mat-grid-list>
<!--                    <mat-form-field fxFlexOffset="20px" fxFlex="20%" appearance="outline">
                        <ngx-mat-file-input formControlName="componentFile" accept=".pdf" valuePlaceholder="Click to upload Candidate Docs" placeholder="Click to Upload Candidate Docs" ></ngx-mat-file-input>
                        <mat-label>Upload Candidate Docs</mat-label>
                    </mat-form-field>
                    <button style="margin-top:10px;height:35px" mat-raised-button color="primary" fxFlexOffset="20px" (click)="uploadFile()">Add</button>                                                 -->

                   


                        <!-- Added By Navin on 15/2/24 -->

                   <!-- <button type="submit"  [disabled]="!loginForm.valid" mat-raised-button color="primary" (click)="submit()">Login</button> -->
                   <button type="submit"  mat-raised-button color="primary" style="color: white; width: 55px; height: 36px; border-radius: 9px; margin-bottom: 3px; text-align: center; position: absolute; right: 47px; top: 259px; " [disabled]="personalDetailsDataEntryForm.invalid" matTooltip="Save Personal Details" mat-icon-button (click)="saveConfirmation()"> Save </button>

                </form>
            </div>
            <div *ngIf="statusInDb == 'CDE-REJECTED'">
                <mat-form-field appearance="outline">
                    <textarea readonly matInput cols="30" rows="3" [(ngModel)]="inputqcComments" placeholder="Rejection Remarks"></textarea>
                    <mat-label>Rejection Remarks</mat-label>
                </mat-form-field>
           </div>
        </div>

    </mat-sidenav-content>
</mat-sidenav-container>

